/**
 * DVL — collection description Show more toggle (Dawn)
 * ====================================================
 * The description is one multi-column flow: every paragraph and the toggle are
 * siblings in the same container, so the text runs column one -> column two
 * without a break and the toggle travels at the end of whatever is visible.
 * A <details> element cannot do that — its summary would split the flow in two.
 *
 * Progressive enhancement: the markup ships expanded with the button hidden, so
 * without JavaScript the full description renders exactly as Dawn had it. This
 * script reveals the button and collapses the copy.
 */
(function () {
  'use strict';

  var COLLAPSED = 'dvl-description--collapsed';

  function setup(root) {
    if (!root || root.dataset.dvlDescriptionReady === 'true') return;
    var toggle = root.querySelector('.dvl-description__toggle');
    if (!toggle) return;

    root.dataset.dvlDescriptionReady = 'true';
    toggle.hidden = false;

    function collapse(on) {
      root.classList.toggle(COLLAPSED, on);
      toggle.setAttribute('aria-expanded', on ? 'false' : 'true');
    }

    collapse(true);

    toggle.addEventListener('click', function () {
      collapse(!root.classList.contains(COLLAPSED));
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-dvl-description]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // The theme editor re-renders a section without reloading the page.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
